<template>
    <div>
        <multiselect class="form-control" v-model="modelo.idmodulo" :options="datos" track-by="idmodulo" label="nombre"
        :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Seleccione..."></multiselect>

        <p class="text-primary"> <small>{{datos.length}} modulos.</small> </p>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
export default {
    props:{ model:Object,programa:{type:Object,required:true} },
    data(){
        return{
            datos: [],
            modelo: {
                idmodulo: null,
            }
        }
    },
    watch:{
        'modelo.idmodulo': function(){this.model.idmodulo=this.modelo.idmodulo; },
        'programa.id': function(){ this.getDatos() },
    },
    methods:{
        async getDatos() {
            if( !this.programa.id ) return;
            
            var vue = this;
            if( this.programa == null ) {
              window.console.error( "AULAS: no hay programa seleccionado" );
              return;
            }
            var sql = gql`query{ getPrograma(id:${this.programa.id}){ programa_modulos{ idmodulo,numero,inicio,fin,modulo{nombre} } } }`;
            window.console.log( sql );
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                var dat = [];
                data.data.getPrograma.programa_modulos.forEach( function(e){
                  e.nombre = e.modulo.nombre;
                  dat.push( e );
                })
                vue.datos = dat;
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getPrograma' ) )
            })
        },
    },
    mounted(){
        this.getDatos();
    }
}
</script>